import { XPay } from '@xstak/xpay-element-stage';
import React from 'react';
import { Payment } from '../../pages/Payment';

const PaymentMethods = ({ loading, merchantSettings, formik, shouldShowXPay, xPay }) => {

    return (
        <div className="checkout-step">
            <div className="step-header">
                <h3>Payment Method</h3>
            </div>
            <div className="step-content">
                <div className="payment-methods">
                    {loading ? (
                        <div className="payment-method-skeleton">
                            <div className="skeleton-bar"></div>
                            <div className="skeleton-bar"></div>
                        </div>
                    ) : merchantSettings?.merchant_integrations?.length > 0 ? (
                        <>
                            {merchantSettings.merchant_integrations.map((method, index) => (
                                <div
                                    key={`payment-${index}`}
                                    className={`payment-method ${formik.values.payment_id === method.random_id ? 'selected' : ''} ${!!xPay && method.integration_method_id !== 35 ? 'disabled' : ''}`}
                                    style={!!xPay && method.integration_method_id !== 35 ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(100%)' } : {}}
                                >
                                    <input
                                        type="radio"
                                        id={`payment-${method.random_id}`}
                                        name="payment_id"
                                        value={method.random_id}
                                        checked={formik.values.payment_id === method.random_id}
                                        onChange={formik.handleChange}
                                        disabled={!!xPay && method.integration_method_id !== 35}
                                    />
                                    <label
                                        htmlFor={`payment-${method.random_id}`}
                                        className="method-content"
                                    >
                                        <div className="method-info">
                                            <i className={method.icon}></i>
                                            <span className="method-name">{method.display_name}</span>
                                        </div>
                                        {method.image && (
                                            <img src={method.image} alt={method.display_name} className="method-logo" />
                                        )}
                                    </label>
                                </div>
                            ))}
                            {shouldShowXPay && xPay && (
                                <>
                                    <XPay
                                        xpay={{
                                            publishableKey: xPay.api_key,
                                            accountId: xPay.account_id,
                                            hmacSecret: xPay.hmac_secret
                                        }}
                                    >
                                        <Payment
                                            slug={xPay.slug}
                                            orderRef={xPay.order_ref}
                                            instanceId={xPay.instance_id}
                                            orderDate={xPay.order_date}
                                            merchantId={xPay.merchant_id}
                                        />
                                    </XPay>
                                </>
                            )}
                        </>
                    ) : (
                        <div className="no-payment-methods">
                            No payment methods available
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentMethods; 